export const LOAD_PAGINATE_TICKETS = 'LOAD_PAGINATE_TICKETS'
export const ADD_CATEGORY_TICKETS = 'ADD_CATEGORY_TICKETS'
export const ADD_CUSTOMER_PRIORITIES = 'ADD_CUSTOMER_PRIORITIES'
export const ADD_TICKETS_STATUS = 'ADD_TICKETS_STATUS'
export const ADD_TICKETS_CONTACTS = 'ADD_TICKETS_CONTACTS'
export const ADD_CONTACT_PRODUCTS = 'ADD_CONTACT_PRODUCTS'
export const ADD_TICKET = 'ADD_TICKET'
export const ADD_CATEGORY_TICKET = 'ADD_CATEGORY_TICKET'
export const ADD_CATEGORY_TICKET_STATUS = 'ADD_CATEGORY_TICKET_STATUS'
export const CHANGE_CATEGORY_PRODUCT_STATUS = 'CHANGE_CATEGORY_PRODUCT_STATUS'